import { useMutation } from '@apollo/client'
import {
  SAVE_BACKUP_APPROVERS,
  SaveBackupApproversRequestInput,
  SaveBackupApproversResponse,
} from 'queries/mutations/save-backup-approvers'

export const useSaveBackupApprovers = () => {
  const [saveBackupApprovers, { data, loading, error }] = useMutation<
    SaveBackupApproversResponse,
    SaveBackupApproversRequestInput
  >(SAVE_BACKUP_APPROVERS)

  return {
    saveBackupApprovers,
    data,
    loading,
    error,
  }
}
